export function jsonToFormData<T extends Record<any, any>>(object: T) {
  const formData = new FormData();

  Object.keys(object).forEach((key) => formData.append(key, object[key]));

  return formData;
}
